import { supabase, hasSupabase } from './supabase.js';

const CHANNEL_NAME = 'story-editor-status';
const CHANNEL_TOPIC = `realtime:${CHANNEL_NAME}`;

let channel = null;
let bindingsRegistered = false;
let subscriberId = 0;
/** @type {Map<number, { onEpisode?: Function, onRenderJob?: Function, onPublishJob?: Function }>} */
const listeners = new Map();

function dispatch(table, payload) {
  for (const h of listeners.values()) {
    if (table === 'reels_episodes') {
      if (payload.eventType === 'DELETE') h.onEpisodeDelete?.(payload.old.id);
      else h.onEpisode?.(payload.new);
    }
    else if (table === 'reels_render_jobs') h.onRenderJob?.(payload.new || payload.old);
    else if (table === 'reels_publish_queue') h.onPublishJob?.(payload.new || payload.old);
  }
}

function registerBindings(ch) {
  if (bindingsRegistered) return;
  ch.on(
    'postgres_changes',
    { event: '*', schema: 'public', table: 'reels_episodes' },
    (payload) => dispatch('reels_episodes', payload),
  );
  ch.on(
    'postgres_changes',
    { event: '*', schema: 'public', table: 'reels_render_jobs' },
    (payload) => dispatch('reels_render_jobs', payload),
  );
  ch.on(
    'postgres_changes',
    { event: '*', schema: 'public', table: 'reels_publish_queue' },
    (payload) => dispatch('reels_publish_queue', payload),
  );
  bindingsRegistered = true;
}

function ensureChannel() {
  if (channel) return;

  const existing = supabase.getChannels().find((c) => c.topic === CHANNEL_TOPIC);
  if (existing) {
    channel = existing;
    return;
  }

  channel = supabase.channel(CHANNEL_NAME);
  registerBindings(channel);
  channel.subscribe();
}

/** Subscribe to status changes on reels tables. Returns unsubscribe. */
export function subscribeStatus(handlers) {
  if (!hasSupabase()) return () => {};
  const id = ++subscriberId;
  listeners.set(id, handlers);
  ensureChannel();
  return () => {
    listeners.delete(id);
  };
}
